<app-loader
	[enableCircle]="true"
	[isActive]="isLoading.value$ | async"
	[isAfterViewInit]="false"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start gap-2">
		<div>{{ 'comego.fixRulbreak' | translate }}</div>
		<div class="flex-auto"></div>
	</div>
</h1>

<mat-dialog-content
	cdkTrapFocus
	class="!overflow-y-auto !max-h-[calc(100vh-200px)]"
>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		*ngIf="this.group as grp"
		class="flex flex-col"
	>
		<div class="flex flex-row gap-2">
			<div class="my-3 flex flex-auto flex-col items-stretch justify-start gap-2 lg:wflex-[1_0_440px]">
				<div class="flex w-full flex-row flex-nowrap items-center gap-3">
					<ng-container *ngIf="workspace$canManageOthers.value$ | async">
						<ng-container *ngIf="groupValue.user as user">
							<div class="flex min-w-0 flex-auto items-center space-x-1.5">
								<app-user-avatar
									[userId]="user.id"
									class="rounded-full"
									size="40px"
								></app-user-avatar>
								<span class="truncate pl-1 leading-none">{{ user.name }}</span>
							</div>
							<mat-divider
								class="h-8 self-center"
								vertical
							></mat-divider>
						</ng-container>
					</ng-container>
					<div class="flex min-w-0 flex-auto flex-row items-center gap-1.5">
						<mat-icon class="text-muted prefix-icon !text-base !leading-none self-center !mb-2"
							>calendar_month</mat-icon
						>
						<span class="truncate align-middle">{{ groupValue.date | formatDate }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="mat-bd-5 mb-3 flex flex-col rounded-lg px-4 py-3">
			<div class="flex flex-col w-full mb-2 gap-1">
				<div class="font-bold text-lg">{{ 'comego.suggestion.projectTimesTitle' | translate }} </div>
				@if(!restBetweenDaysError) { @if(projectTimeData?.existingDuration > 0) {
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.existingDuration' | translate }}:</span>
					<span class="ml-auto"> {{ projectTimeData?.existingDuration | parseMsAsDuration: false }} h</span>
				</div>
				}
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.addDuration' | translate }}: </span>
					<span class="ml-auto"> {{ projectTimeData?.addDuration | parseMsAsDuration: false }} h</span>
				</div>
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.totalBreakDuration' | translate }}: </span>
					<span class="ml-auto"> {{ projectTimeData?.totalBreakDuration | parseMsAsDuration: false }} h</span>
				</div>
				<mat-divider horizontal></mat-divider>
				@if(projectTimeData?.totalDuration > ((workingHoursRules$ | async)?.dailyMaxHours * 3600 )) {
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.totalDuration' | translate }}: </span>
					<span class="ml-auto text-red-500">
						{{ projectTimeData?.totalDuration | parseMsAsDuration: false }}
						h</span
					>
				</div>
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.maxWorkTime' | translate }}: </span>
					<span class="ml-auto">
						{{ ((workingHoursRules$ | async)?.dailyMaxHours * 3600 ) | parseMsAsDuration }}
						h</span
					>
				</div>
				} @else {
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.totalDuration' | translate }}: </span>
					<span class="ml-auto"> {{ projectTimeData?.totalDuration | parseMsAsDuration: false }} h</span>
				</div>
				} } @else { @if (restData?.side === 'prev') {
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.previousDay' | translate }}:</span>
					<span class="ml-auto"> {{ restData?.adjacentClock }}</span>
				</div>
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.newEntry' | translate }}:</span>
					<span class="ml-auto"> {{ restData?.entryClock }}</span>
				</div>
				} @else {
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.newEntry' | translate }}:</span>
					<span class="ml-auto"> {{ restData?.entryClock }}</span>
				</div>
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.nextDay' | translate }}:</span>
					<span class="ml-auto"> {{ restData?.adjacentClock }}</span>
				</div>
				}
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.availableRestTime' | translate }}:</span>
					<span class="ml-auto text-red-500">
						{{ restData?.availableRestDuration | parseMsAsDuration: false }}
						h</span
					>
				</div>
				<mat-divider horizontal></mat-divider>
				<div class="flex flex-row">
					<span>{{ 'comego.suggestion.neccasaryRestTime' | translate }}:</span>
					<span class="ml-auto"> {{ restData?.requiredRestDuration | parseMsAsDuration: false }} h</span>
				</div>
				}
			</div>
			@if (violationNotices.length) {
			<div class="flex flex-row items-start gap-2 rounded-lg border border-orange-500 bg-orange-500/10 p-2">
				<mat-icon class="mt-0.5 shrink-0 text-orange-500 leading-none">warning</mat-icon>
				<div class="mb-1 flex flex-col">
					@for (notice of violationNotices; track $index) {
					<div class="rounded">{{ notice }}</div>
					}
				</div>
			</div>
			}
		</div>
		<div class="mat-bd-5 flex flex-col rounded-lg px-4 pt-3 pb-3">
			<div class="xs:mb-4 mb-0 flex">
				<div class="flex flex-grow flex-col">
					<div class="flex flex-col gap-1">
						<span class="font-bold text-lg"> {{ 'comego.suggestion.entriesTitle' | translate }} </span>
						@if (isOverDailyMaxWorkTime) {
						<span class="text-sm text-gray-500">
							{{
								'comego.suggestion.entriesDescriptionMaxExceeded' | translate: { hours:
							creditableNewProjectTimeSeconds | parseMsAsDuration: false }
							}}
						</span>
						} @else {
						<span class="text-sm text-gray-500">
							{{
								(scheduleRangesText ? 'comego.suggestion.entriesDescriptionKeptSchedule' :
							'comego.suggestion.entriesDescriptionKept') | translate: { schedule: scheduleRangesText }
							}}
						</span>
						}
					</div>
				</div>
			</div>
			<div class="-mx-4 flex flex-col gap-2">
				<div class="mat-hint flex flex-row items-center gap-3 px-4 pb-1 text-sm font-semibold">
					<div class="w-[164px] shrink-0 font-bold">{{ 'comego.type' | translate }}</div>
					<div class="w-32 shrink-0 font-bold">
						{{ 'timer.time.start' | translate }}
						- {{ 'timer.time.end' | translate }}
					</div>
					<div class="ml-auto w-24 shrink-0 font-bold text-center">{{ 'task.status' | translate }}</div>
					<div class="w-16 shrink-0 text-right font-bold mr-3">{{ 'timer.time.duration' | translate }}</div>
				</div>
				<ng-container
					*ngFor="let comegoGroup of group.controls.times.controls; let ctrlIndex = index; trackBy: ctrlIndex"
				>
					<div
						class="flex flex-row items-center gap-3 border-t border-gray-300 px-4 pt-4 pb-2 dark:border-neutral-700"
					>
						<!-- Icon-->
						<div
							[ngClass]="[
							comegoGroup.getRawValue()?.type === 'work'
								? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
								: comegoGroup.getRawValue()?.type === 'absence'
									? 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100'
									: comegoGroup.getRawValue()?.type === 'pause'
										? 'dark:bg-neutral-600 bg-neutral-600/80'
										: comegoGroup.getRawValue()?.recording
											? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
											: 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100',
						]"
							*ngIf="calcType(iconMap[comegoGroup.getRawValue()?.type]) as type"
							class="flex size-6 shrink-0 items-center justify-center rounded-full p-0 leading-6 text-neutral-100"
						>
							<mat-icon
								class="text-center"
								inline
							>
								{{ type }}
							</mat-icon>
						</div>
						<!-- Type -->
						<div class="w-32 shrink-0 truncate">
							<ng-container [ngSwitch]="comegoGroup.getRawValue()?.type">
								<ng-container *ngSwitchCase="'work'">{{
									'comego.types.work' | translate
								}}</ng-container>
								<ng-container *ngSwitchCase="'pause'">{{
									'comego.types.pause' | translate
								}}</ng-container>
								<ng-container *ngSwitchCase="'absence'">{{
									'comego.types.absence' | translate
								}}</ng-container>
								<ng-container *ngSwitchDefault>
									<ng-container *ngFor="let sub of absenceSubcategories">
										<ng-container *ngIf="sub.id === comegoGroup.getRawValue()?.type">{{
											sub | absenceTranslate
										}}</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
						<!-- Time start/end  -->
						<div class="w-32 shrink-0">
							{{ comegoGroup.getRawValue()?.start }}
							- {{ comegoGroup.getRawValue()?.end }}
						</div>
						<!-- Origin -->
						<div class="ml-auto w-24 shrink-0 flex items-center">
							<span
								[ngClass]="
									getEntryOrigin(comegoGroup) === 'existing'
										? 'border-green-300 bg-green-50 text-green-700 dark:border-green-400/40 dark:bg-green-950/30 dark:text-green-300'
										: 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-400/40 dark:bg-blue-950/30 dark:text-blue-300'
								"
								class="inline-block rounded border px-2 py-0.5 text-xs"
							>
								{{
									(getEntryOrigin(comegoGroup) === 'existing' ? 'comego.suggestion.entryExisting' :
								'comego.suggestion.entryAdded') | translate
								}}
							</span>
						</div>
						<!-- Duration -->
						<div class="w-16 shrink-0 text-right">
							{{ calculateDuration(comegoGroup, ctrlIndex) | parseMsAsDuration: false }}
							h
						</div>
					</div>
				</ng-container>
			</div>
			<div class="-mx-4">
				<ng-container *ngIf="duration$ | async as dur">
					<div class="flex flex-col gap-2 border-t border-gray-300 px-4 pt-2 dark:border-neutral-700">
						<div class="flex flex-row items-center">
							<span class="font-bold">{{ 'comego.suggestion.totalWork' | translate }}</span>
							<span class="ml-auto w-16 text-right font-bold">
								{{ dur.working | parseMsAsDuration: false }}
								h
							</span>
						</div>
						<div class="flex flex-row items-center">
							<span class="font-bold">{{ 'comego.suggestion.totalBreak' | translate }}</span>
							<span class="ml-auto w-16 text-right font-bold">
								{{ dur.pause | parseMsAsDuration: false }}
								h
							</span>
						</div>
						@if(projectTimeData?.totalDuration > ((workingHoursRules$ | async)?.dailyMaxHours * 3600 )) {
						<div class="flex flex-row items-center">
							<span class="font-bold">{{ 'comego.suggestion.overMaxWork' | translate }}</span>
							<span class="ml-auto w-16 text-right font-bold text-red-500">
								{{
									(projectTimeData?.totalDuration - ((workingHoursRules$ | async)?.dailyMaxHours * 3600 ) )| parseMsAsDuration: false
								}}h
							</span>
						</div>
						}
					</div>
				</ng-container>
			</div>
		</div>
	</form>
</mat-dialog-content>
<ng-container
	*ngIf="{
      times: getErrorObservable('times') | async,
      manual: error$.value$ | async,
    } as error"
>
	<div class="inset-x-0 mx-4 my-4">
		<div
			*ngIf="error.manual as err"
			class="alert alert-danger alert-tight rounded py-2"
		>
			{{ err.message | translate: (err.args | translateArgs) }}
		</div>
		<ng-container *ngIf="!error.manual && error.times && error.times.index === undefined && error.times as br">
			<div
				[matTooltip]=" br.content === 'errors.times.comego.breakRuleNotice' ?
			('errors.times.comego.breakRuleDetailed' | translate: (br.args || {} | translateArgs)): null"
				class="alert alert-danger alert-tight rounded py-2"
			>
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</ng-container>
	</div>
	<div
		*ngIf="(!(canAddTime.value$ | async) && (error.manual || error.times) ) || (showContactAdmin.value$ | async)"
		class="inset-x-0 mx-4 my-4"
	>
		<div class="rounded leading-tight px-3 text-[0.825rem] font-semibold text-destructive-foreground bg-black/55">
			<span class="block py-2">{{ 'errors.times.comego.contactAdmin' | translate }}</span>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="getErrorObservable('date') | async as error">
	<ng-container *ngIf="error as br">
		<div class="inset-x-0 mx-4 mb-4">
			<div class="alert alert-danger alert-tight rounded ">
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-container *ngIf="(overlappingExistingEntryIds$ | async)?.length > 0">
	<div class="inset-x-0 mx-4 mb-4">
		<div class="alert alert-danger alert-tight rounded py-2">{{ 'errors.times.comego.overlap' | translate }}</div>
	</div>
</ng-container>
<div class="mx-6 mb-4">
	<div
		class="flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-400/40 dark:bg-blue-950/30"
		role="status"
	>
		<div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-500 text-white">
			<span>i</span>
		</div>
		<div class="flex flex-col">
			<span class="text-sm">{{ 'comego.suggestion.projectTimeUnchanged' | translate }}</span>
			@if (projectTimeData?.totalDuration > ((workingHoursRules$ | async)?.dailyMaxHours * 3600 )) {
			<span class="text-sm">{{
				'comego.suggestion.suggestionDeviationHintMinutes' | translate: { minutes:  ( projectTimeData?.totalDuration -((workingHoursRules$ | async)?.dailyMaxHours * 3600 )) | parseMsAsDuration: false }
			}}</span>
			} @else if (restBetweenDaysError) {
			<span class="text-sm">{{ 'comego.suggestion.suggestionDeviationResttime' | translate }}</span>
			} @else {
			<span class="text-sm">{{ 'comego.suggestion.suggestionDeviationHint' | translate }}</span>
			}
		</div>
	</div>
</div>
<mat-dialog-actions class="!box-border !block w-full max-w-full min-w-0 overflow-x-hidden !p-0 !mb-0">
	<div class="box-border grid min-w-0 w-full max-w-full grid-cols-3 gap-8 px-3">
		<div class="flex min-w-0">
			<button
				(click)="cancelAction()"
				[disabled]="isLoading.value$ | async"
				class="!box-border w-full max-w-full min-w-0"
				mat-stroked-button
			>
				<span class="truncate">{{ 'utils.cancel' | translate }}</span>
			</button>
		</div>
		<div class="flex min-w-0 items-center justify-center">
			@if (pendingProjectionFix) {
			<button
				(click)="saveWithViolation()"
				[disabled]="isLoading.value$ | async"
				[matTooltip]="'comego.stopWithoutCorrectionTooltip' | translate"
				class="!box-border w-full max-w-full min-w-0 !px-0"
				color="warn"
				mat-stroked-button
			>
				<span class="truncate">{{ 'comego.stopWithoutCorrection' | translate }}</span>
			</button>
			}
		</div>
		<div class="flex min-w-0">
			<button
				(click)="submit()"
				[color]="'primary'"
				[disabled]=" (!error.times?.warning && group.invalid || (( error$.value$ | async) && !error$.value?.test) ) && (preventDeviatingWorkingHours | async )|| ((overlappingExistingEntryIds$ | async)?.length > 0)"
				[matTooltip]="'comego.submitFixTooltip' | translate"
				*ngIf="{ times : getErrorObservable('times') | async } as error"
				class="!box-border w-full max-w-full min-w-0 rounded-lg !border-primary !bg-primary !text-primary-foreground"
				mat-stroked-button
			>
				<span class="truncate">{{ 'comego.submitFix' | translate }}</span>
			</button>
		</div>
	</div>
</mat-dialog-actions>
